import { ReactNode } from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type ExpandableSectionProps = {
    title: string;
    icon: ReactNode;
    expanded: boolean;
    onChange: (expanded: boolean) => void;
    children: ReactNode;
    hasMarginBottom?: boolean;
};

export const ExpandableSection = ({
    title,
    icon,
    expanded,
    onChange,
    children,
    hasMarginBottom = false,
}: ExpandableSectionProps) => {
    const theme = useTheme();

    return (
        <Accordion
            expanded={expanded}
            onChange={() => onChange(!expanded)}
            disableGutters
            square
            sx={{
                bgcolor: "transparent",
                color: "inherit",
                "&:before": { display: "none" },
                borderRadius: 1,
                ...(hasMarginBottom && { mb: 1 }),
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.text.secondary }} />}
                sx={{
                    px: 2,
                    py: 1.5,
                    "&:hover": {
                        bgcolor: theme.palette.action.hover,
                    },
                    borderRadius: 1,
                }}
            >
                <Box display="flex" alignItems="center" gap={1.5}>
                    {icon}
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, pb: 2 }}>{children}</AccordionDetails>
        </Accordion>
    );
};
